import React, { useContext, useRef, useState } from 'react'
import SvgViewer from './SvgViewer'
import SvgViewerToolbar from './SvgViewerToolbar'
import CodeMirror from '@uiw/react-codemirror'
import beautify from 'js-beautify'
import { ConnectorViewMappingContext } from './context/context'

const ConnectorImage = (props) => {
  const [connVwMpState, dispatch] = useContext(ConnectorViewMappingContext)

  const [state, setState] = useState({
    connectors: [],
    svg: '',
    initialZoomLevel: null,
    fontSize: 10,
  })

  const onToolbarChange = (key) => {
    setState({ ...state, [key]: !this.state[key] })
  }
  const panZoom = useRef()

  const resetState = () => {
    panZoom.current = null
    setState({
      ...state,
      defaultZoomPercentage: null,
      initialZoomLevel: null,
      prevZoomLevel: null,
      prevZoomPercentage: null,
      svg: null,
      zoomLevel: null,
      zoomPercentage: null,
    })
  }

  const onBeforeZoom = (prevZoom, newZoom) => {
    // TODO dynamically resize elements as needed...
    return
  }

  const onSvgReady = (svg, panZoomObj) => {
    resetState()

    // Max out the size of the svg container
    svg.setAttribute('width', '100%')
    svg.setAttribute('height', '100%')

    // Register panzoom events
    panZoom.current = panZoomObj
    panZoom.current.setBeforeZoom(onBeforeZoom)
    panZoom.current.setZoomScaleSensitivity(0.2)
    panZoom.current.setMinZoom(0.3)

    // Center the SVG and have it fit its container
    panZoom.current.resize()
    panZoom.current.contain()
    panZoom.current.center()

    const initialZoomLevel = panZoom.current.getZoom()
    setState({
      ...state,
      svg,
      svgSource: beautify.html(svg.outerHTML),
      initialZoomLevel,
    })
  }

  const setFontSize = (size) => {
    if (size > 0) {
      setState({ ...state, fontSize: size })
    }
  }

  const onReferenceSelect = (ref) => {}

  return (
    <div className="w-4/5 flex flex-grow flex-col items-stretch bg-tracer-darker-blue">
      <SvgViewerToolbar
        onChange={onToolbarChange}
        displayGroups={state?.displayGroups}
        displaySource={state?.displaySource}
        displayMappings={state?.displayMappings}
        displayPng={state?.displayPng}
      />

      <div
        className={connVwMpState?.displaySource ? '' : 'hidden'}
        style={{ width: '100%', height: '100%' }}
      >
        <CodeMirror
          value={state?.svgSource}
          options={{
            readOnly: true,
            mode: 'html',
            theme: 'lucario',
            foldGutter: true,
          }}
        />
      </div>

      <style>
        {`text
            {
              opacity: 0.2;
              font-size: ${state?.fontSize}px;
              fill: white !important;
              cursor: pointer
            }
            .hl, circle
            {
              visibility: hidden;
            }
            g.hlOn .hl,
            g.selectedSvgElement .hl
            {
              visibility: visible;
            }
            g.hlOn text,
            g.selectedSvgElement text,
            g[id='${connVwMpState?.selected_reference}'] text
            {
              fill: yellow !important;
              stroke: black !important;
              opacity: 1 !important;             
              stroke-width:0.5em !important; 
              fill:black; 
              paint-order:stroke; 
              stroke-linejoin:round
            }
            g.hlOn circle,
            g.selectedSvgElement circle,
            g[id='${connVwMpState?.selected_reference}'] circle
            {
              fill: none !important;
              stroke: yellow;
              opacity: 1;
            }
            g[id='${connVwMpState?.selected_reference}'] *           
            {
              fill: yellow !important;
              stroke: yellow !important;
              text-decoration: underline;
              font-weight: bold;
              font-size: ${state?.fontSize * 2}px;
            }
            .mappedSvgElement{
              fill: orange !important;
              stroke: black !important;
              opacity: 1;
            }
            g.mappedSvgElement text
            {
             
              fill: orange !important;
              stroke: black !important;
              opacity: 1 !important;             
              stroke-width:0.5em !important; 
              fill:black; 
              paint-order:stroke; 
              stroke-linejoin:round;
              font-weight: bold;
              font-size: ${state?.fontSize * 2}px;

            }
            g.mappedSvgElement circle
            {
              fill: none !important;
              stroke: orange;
              opacity: 1;
            }
            g[id='${connVwMpState?.selected_reference}'] text,
            g[id='${connVwMpState?.selected_reference}'] .hl,
            g.mappedSvgElement text,
            g.mappedSvgElement .hl,
            g[id='${connVwMpState?.selected_reference}'] circle,
            g.mappedSvgElement circle
            {
              visibility: visible;
            }`}
        {!connVwMpState?.displayMappings &&
          `g.mappedSvgElement text,
               g.mappedSvgElement .hl
               {
                 visibility: hidden;
               }`}
        {!connVwMpState?.displayGroups &&
          `text, circle
            {
              visibility: hidden;
            }`}
        {!connVwMpState?.displayPng &&
          `image
            {
              visibility: hidden;
            }`}
      </style>
      {connVwMpState?.connector_view?.svg && (
        <SvgViewer
          hidden={connVwMpState?.displaySource}
          src={connVwMpState?.connector_view?.svg}
          background={connVwMpState?.connector_view?.svg}
          panzoom
          onReady={(svg, panzoom) => {
            onSvgReady(svg, panzoom)
          }}
          setFontSize={(size) => {
            setFontSize(size)
          }}
          errorComponent={<div>Failed to display svg</div>}
          mappedReferences={connVwMpState?.connector_view?.references}
          onReferenceSelect={(id) => {
            onReferenceSelect(id)
          }}
          backgroundImage={connVwMpState?.connector_view?.png}
        />
      )}
    </div>
  )
}

ConnectorImage.propTypes = {}

export default ConnectorImage
